import { combineReducers } from 'redux'
import { alert } from './Alert/alert.reducer'
import { application } from './Application/application.reducer'
import { audit } from './Audit/audit.reducer'
// import { boats } from './Boat/boat.reducer'
import { client } from './Client/client.reducer'
import { clientAdmin } from './ClientAdmin/clientAdmin.reducer'
// import { documents } from './Document/document.reducer'
// import { equipments } from './Equipment/equipment.reducer'
// import { equipmentTemplates } from './EquipmentTemplate/equipmentTemplate.reducer'
import { intranet } from './Intranet/intranet.reducer'
// import { mainCategories } from './MainCategories/mainCategories.reducer'
import { service } from './Service/service.reducer'
import { authentication } from './User/authentication.reducer'
import { user } from './User/user.reducer'

export const rootReducer = combineReducers({
  alert,
  authentication,
  application,
  audit,
  // boats,
  // mainCategories,
  // equipments,
  // equipmentTemplates,
  // documents,
  intranet,
  clientAdmin,
  client,
  service,
  user,
})
